import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBarComponent } from './dashboard/top-bar/top-bar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './dashboard/footer/footer.component';
import { LeftMenuComponent } from './dashboard/left-menu/left-menu.component';
import { SharedPrimengModule } from '../shared/shared-primeng.module';
import { SelectModule } from 'primeng/select';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    DashboardComponent,
    FooterComponent,
    LeftMenuComponent,
    TopBarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule  ,
    SharedModule,
    SharedPrimengModule,
    SelectModule
  ]
})
export class CoreModule { }
